export default {
	tenantId: "coverHealth_preprod_eu",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "covergo-euce1-preprod",
	},
}
